import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { usePlatform } from '@hellodarwin/core/lib/features/providers/platform-provider';
import Divider from 'antd/es/divider';
import Drawer from 'antd/es/drawer';
import { useEffect, useMemo } from 'react';
import { useTheme } from 'styled-components';
import UserMenu from '../../app-layout/components/user-menu';
import NavigationMenuItem from '../menu-item';
import Socials from '../socials';
import { MobileNavigationContainer } from '../styles';
import { MobileNavigationCtas, MobileNavigationHdNavigationFooter, } from './styles';
const MobileNavigation = ({ links, profile, userLinks, pathname, }) => {
    const { app, menuOpen, toggleMenu } = usePlatform();
    const theme = useTheme();
    useEffect(() => {
        document.body.style.overflow = menuOpen ? 'hidden' : '';
    }, [menuOpen]);
    useEffect(() => {
        if (menuOpen)
            toggleMenu();
    }, [pathname]);
    const selectedKeys = useMemo(() => { var _a; return (_a = links.map((l) => l.pathname)) !== null && _a !== void 0 ? _a : []; }, [links]);
    return (_jsx(_Fragment, { children: _jsx(Drawer, { styles: {
                wrapper: {
                    marginBlockStart: theme.appearance.appHeaderHeight,
                },
                header: {
                    padding: 0,
                    flexDirection: 'row-reverse',
                },
                content: {
                    background: app === 'provider' ? theme.colors.primary : theme.colors.white_1,
                    padding: 0,
                },
            }, zIndex: 100, closable: false, placement: "right", onClose: toggleMenu, open: menuOpen, width: '100%', children: _jsxs(MobileNavigationContainer, { "$open": menuOpen, children: [_jsx(MobileNavigationCtas, { children: links
                            .filter((link) => !link.hide)
                            .map((link) => (_createElement(NavigationMenuItem, Object.assign({}, link, { key: link.pathname, selectedKeys: selectedKeys, isMobile: true })))) }), profile && userLinks && (_jsxs(MobileNavigationHdNavigationFooter, { className: "hd-navigation-footer", children: [app !== 'admin' && _jsx(Socials, { withoutBorder: true, align: "right" }), _jsx(Divider, { style: {
                                    borderWidth: 1,
                                    borderColor: app === 'provider'
                                        ? theme.colors.white_1
                                        : theme.colors.grey_4,
                                } }), _jsx(UserMenu, { user: {
                                    name: profile.contact_name,
                                    logo: profile.logo,
                                    email: profile.contact_email,
                                }, links: userLinks })] }))] }) }) }));
};
export default MobileNavigation;
